import React, { useEffect, useState } from 'react'
import { profileEndpoints } from "../../../services/apis"
import { apiConnector } from '../../../services/apiconnector';
import {toast} from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { FaSearch } from "react-icons/fa";

import StudentsCard from '../../common/StudentsCard';

function AllStudents() {
    const {  GET_ALL_USERS } = profileEndpoints
const[students ,setStudents] = useState([])
const [loading, setLoading] = useState(false);
const { token } = useSelector((state) => state.auth);
const [filterStudent,setFilterstudent] = useState([])
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);

const fetchStudents =  async (page) => {
   
    // const toastId = toast.loading("Loading...")
    setLoading(true)
    try {
        const response = await apiConnector("GET", `${GET_ALL_USERS}?page=${page}&limit=10)`,null,{
          Authorization: `Bearer ${token}`,
        })
        console.log("GET_ALL_CATEGORY_API API RESPONSE............", response.data.data)
       
        if (!response?.data?.success) {
          throw new Error("Could Not Fetch Students")
        }
        const { data, pagination } = response.data;
        console.log(pagination)

      setStudents(data);
      setTotalPages(pagination.totalPages);

       
        setFilterstudent(data)
       
       
      } catch (error) {
        console.log("GET_ALL_USERS API ERROR............", error)
        // toast.error(error.message)
      }

    ;
    // toast.dismiss(toastId)
    setLoading(false)
    
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    const searchText = e.target.value.toLowerCase();
    if (searchText === "") {
      setFilterstudent(students);
      return;
    }
  
    const filteredBySearch = students.filter((item) => {
      const fullName = `${(item.firstName || "").toLowerCase()} ${(item.lastName || "").toLowerCase()}`;
      const libraryID = String(item.libraryId);
      return (
        fullName.includes(searchText) ||
        libraryID.includes(searchText)
      );
    });
    setFilterstudent(filteredBySearch);
  };
  
  
  useEffect(()=>{
    fetchStudents(currentPage);
  },[currentPage])

  return (
    <div>
            <div className='flex justify-center '>
                <h1 className='lg:text-2xl  text-xl font-mulish font-bold '>Students Details</h1>
            </div>
            <div className="flex space-y-2 lg:lg:w-[400px] w-full md:w-[230px] items-center gap-2">
                <FaSearch className="text-2xl " />

                <input
                  type="text"
                  className="shadow-black bg-blue-100 rounded-3xl p-2 text-black placeholder:text-black"
                  onChange={handleSearch}
                  placeholder="Search by Name & Library ID"
                />
              </div>
              
             
              <div className='flex justify-end '>
        <button
          className={`bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l ${currentPage === 1 ? " opacity-0": ""}`}
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className='bg-gray-300 text-gray-800 font-bold py-2 px-4'>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={` bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-r ${currentPage === totalPages ? " opacity-0": ""}`}
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next 

        </button>
      </div>
      
{
  loading ? <div className="grid  place-items-center">
          <div className="spinner"></div>
        </div> : (
    <div className='pt-12'>
       <StudentsCard
       students={filterStudent}
        />
        </div>
  )
}
       
    </div>
  )
}

export default AllStudents
